import { css } from '@emotion/css';
import React from 'react';

export const AppIconImageContainer: React.FC = ({ children }) => (
  <span
    className={css`
      display: block;
      padding-top: 100%;
      position: relative;
      overflow: hidden;
      .icon-image {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
    `}
  >
    <div className="icon-image">{children}</div>
  </span>
);
